import React from "react";
import { styled } from "styled-components";
import rem from "../../utils/rem";
import Colors from "../../styles/Colors";
// @todo need desktop styles
const StyledTextLink = styled.a `
  color: ${(props) => props.theme === "darkMode" ? Colors.WHITE : Colors.GRAY_DARKEST};
  letter-spacing: ${rem(0.4)};
  font-weight: 500;
  text-decoration: underline;
  &:hover,
  &:focus {
    text-decoration-line: underline;
    color: ${(props) => props.theme === "darkMode" ? Colors.GRAY_LIGHT : Colors.GRAY_DARK};
  }
  &:hover:not(:disabled) {
    cursor: pointer;
  }

  font-size: ${rem(16)};
  line-height: ${rem(24)};
`;
const TextLink = ({ theme, ...props }) => React.createElement(StyledTextLink, { theme: theme, ...props });
export default TextLink;
//# sourceMappingURL=TextLink.js.map